__turbopack_context__.v({
  "editor-code-diff-line": "DiffCodeBlock-module__vgroBq__editor-code-diff-line",
});
